import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

interface SkipLinkProps {
  title: string
  to: `#${string}`
}

export default memo<SkipLinkProps>(function SkipLink({title, to: href}) {
  return (
    <VisuallyHidden as='a' href={href} className='skip-link'>
      {title}
    </VisuallyHidden>
  )
})
